import type { QueryClient } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToastController } from 'smoothie';

import {
    MutationErrorToastOptions,
    MutationSuccessToastOptions,
} from '../../common/components/Toasts';
import { llmServiceFetcher } from '../LlmServiceFetcher';

const invalidateExperiments = (
    queryClient: QueryClient,
    agentId: string,
): void => {
    void queryClient.invalidateQueries({ queryKey: ['experiments', agentId] });
    void queryClient.invalidateQueries({ queryKey: ['experiment', agentId] });
    void queryClient.invalidateQueries({
        queryKey: ['experimentScores', agentId],
    });
};

export const useDeleteExperiment = (agentId: string) => {
    const queryClient = useQueryClient();
    const toast = useToastController();

    return useMutation({
        mutationFn: async (experimentId: string): Promise<void> => {
            await llmServiceFetcher({
                endpoint: `/agents/${encodeURIComponent(agentId)}/dataset/experiments/${encodeURIComponent(experimentId)}`,
                method: 'DELETE',
            });
        },
        onSuccess: () => {
            invalidateExperiments(queryClient, agentId);
            toast.show('Experiment deleted.', MutationSuccessToastOptions);
        },
        onError: (error) => {
            toast.show(
                'Failed to delete the experiment.',
                MutationErrorToastOptions(error.message),
            );
        },
    });
};
